module.exports = __webpack_public_path__ + "img/chart_curve.76921c5d.svg";